import { Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useCallback, useContext } from 'react';
import ProfileListItem from '../common/ProfileListItem';
import { IListItem } from '../../../../interfaces/listItem';
import { ICertificate } from '../../../../interfaces/certificate';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FreelancerService } from '../../../../services/freelancer';
import { FreelancerContext } from '../FreelancerEntity';
import { useNotification } from '../../../../+state/useNotification';
import { ColumnBoxFlexFullWidth } from '../../../common/boxes';
import { getTruncatedName } from '../../../../utils/getTruncatedName';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../../interfaces/errorResponse';
import { FREELANCER_ENTITY_QUERY_KEY } from '../../../../queryHooks/freelancer/useGetFreelancerEntity';

export const CERTIFICATE_QUERY_PARAM = 'certificate';

const CertificateListItem = ({ entity }: IListItem<ICertificate>) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useContext(FreelancerContext);
  const queryClient = useQueryClient();
  const { openErrorToast, openSuccessToast } = useNotification();

  const mutation = useMutation({
    mutationFn: () => FreelancerService.deleteCertificate(user.id, entity.id),
    onSuccess: () => {
      openSuccessToast('Successfully deleted');
      queryClient.invalidateQueries([FREELANCER_ENTITY_QUERY_KEY]);
    },
    onError: (err: AxiosError<IErrorResponse>) => { openErrorToast(err.response?.data.message || err.message);}
  });

  const handleClickEditBtn = useCallback(() => {
    searchParams.set(CERTIFICATE_QUERY_PARAM, entity.id);
    setSearchParams(searchParams);
  }, [entity.id, searchParams, setSearchParams]);

  const deleteCertificateAction = useCallback(() => {
    mutation.mutate();
  }, [mutation]);

  return (
    <ProfileListItem deleteHandler={deleteCertificateAction} editHandler={handleClickEditBtn}>
      <ColumnBoxFlexFullWidth flexGrow={1} width={'100%'} justifyContent={'space-between'}>
        <Typography variant={'h6'} sx={{ wordBreak: 'break-word' }}>
          {entity.name}
        </Typography>

        <Typography sx={{ wordBreak: 'break-word' }}>
          {entity.source}
        </Typography>

        <Typography sx={{ wordBreak: 'break-word' }}>
          {getTruncatedName(entity.description, 100)}
        </Typography>

      </ColumnBoxFlexFullWidth>
    </ProfileListItem>
  );
};

export default CertificateListItem;